import clsx from "clsx";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "@/components/common/button";
import { fetchDelivery } from "~/redux/action-creaters/product";
// @ts-ignore
import { daysTextForm } from "~/utils";

import styles from "../index.module.scss";

export default function ShopsNew({ onBuy, canBuy, isShow, productId }: any) {
  const { deliveryNew } = useSelector((state: any) => state.product);
  const { shops = [] } = useSelector((state: any) => state.contacts);

  const router = useRouter();
  const dispatch = useDispatch();
  useEffect(() => {
    if (shops?.length > 0) {
      dispatch(
        fetchDelivery(
          [productId],
          shops.map((shop: any) => shop.warehouseId).filter(Boolean),
          router.query.time,
          router.query.weekday,
        ),
      );
    }
  }, [shops]);

  // Наличие и срок — одной строкой: отдельный безымянный столбец со сроком
  // читался в отрыве от статуса (комментарий клиента)
  const getAvailability = (delivery: any) => {
    const days = daysTextForm(delivery?.days);
    const type = delivery?.availabilityType ?? "empty";
    if (type === "empty") {
      return { color: "red", text: "Нет в наличии" };
    }
    if (type === "relocation") {
      return {
        color: "green",
        text: days ? `Привезем под заказ ${days}` : "Привезем под заказ",
      };
    }
    const qty = (Number(delivery?.availability) || 0) < 5 ? "Мало" : "Много";
    return {
      color: "green",
      text: days ? `${qty} в наличии, заберете ${days}` : `${qty} в наличии`,
    };
  };

  return (
    isShow && (
      <div>
        <div className={clsx(styles.Table, styles.TableMerged)}>
          <span className={clsx(styles.TableFirst, styles.Head)}>
            Адреса магазинов
          </span>
          <span className={styles.Head}>Режим работы</span>
          <span className={styles.Head}>Наличие</span>
          <span className={styles.HeadLast} />
          {shops?.map((shop: any) => {
            const availability = getAvailability(
              deliveryNew?.find(
                (delivery: any) => +delivery.id === +shop.warehouseId,
              ),
            );
            return (
              // eslint-disable-next-line react/jsx-key
              <>
                <span className={styles.TableFirst}>{shop.name}</span>
                <span>
                  <div className="muted">{shop.workingHours}</div>
                </span>
                <span style={{ color: availability.color }}>
                  {availability.text}
                </span>
                <span className={styles.TableButton}>
                  {canBuy && (
                    <Button
                      label="Оформить покупку"
                      type="outline"
                      onClick={onBuy}
                    />
                  )}
                </span>
              </>
            );
          })}
        </div>
      </div>
    )
  );
}
